import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOwnerDetailParams, TypePostOwnerDetailResponse } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 화주사 정보] 화주사 정보 상세 조회
 */
const usePostOwnerDetail = () => {
  const endPoint = '/api-owner/owner/detail';

  const postOwnerDetail = async (params: TypePostOwnerDetailParams) => {
    return axiosInstance
      .post<TypePostOwnerDetailResponse>(endPoint, {
        ...params,
      })
      .then((data) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postOwnerDetail };
};

export default usePostOwnerDetail;
